import React, { Fragment, useEffect, useState } from 'react';
import { Row, Button } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import RoomCard from './RoomCard';
import AddRoomCard from './AddRoomCard';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { gAPI_Rooms } from '../../../../../constants/APIs';
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import IntlMessages from '../../../../../helpers/IntlMessages';
function AboutRooms({ propertyId, locale }) {
  const [roomDetail, setRoomDetail] = useState([]);
  const [loaded, setLoading] = useState(false);
  const [selectedLang, setSelectedLang] = useState(locale);
  const [categoryList, setCategoryTags] = useState([]);
  useEffect(() => {
    LoadData(selectedLang);
  }, [propertyId, selectedLang]);

  const LoadData = (lang) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Rooms}/${propertyId}?lang=${lang}`,
    })
      .then(res => {
        var categories = [];
        res.data.rooms.map(l => {
          if (l.searchCategoryTags !== undefined && l.searchCategoryTags !== null && l.searchCategoryTags.length > 0) {
            l.searchCategoryTags.map(p => { categories.push({ label: p, value: p }) })
          }
        });
        setCategoryTags(categories);
        setRoomDetail(res.data);
        setLoading(true);
      })
      .catch(err => console.log('err', err));
  }

  const setLanguage = (e) => {
    setLoading(false);
    var lan = e;
    if (e === "zh-TW") {
      lan = "hk";
    }
    setSelectedLang(lan);
    LoadData(lan);
    setLoading(true);
  }

  return (
    <Fragment>
      {loaded && (
        <>
          <div className="mb-4">
            <h4><b><IntlMessages id='property-info.room-types' /></b></h4>
            <p style={{ width: '80%' }}>  <IntlMessages id='dashboards.addRoomDetails' /></p>
          </div>

          <Row>
            <Colxx xxs="4" className="mb-2">
              <AddRoomCard propertyId={propertyId} locale={selectedLang} categoryList={categoryList} />
              {locale && locale === 'en' && <a href="/app/pages/propinfo/publish-ai">
                <Button
                  color="primary"
                  outline
                  className='ml-2'
                  size="xs"
                >
                  Publish AI
                </Button>
              </a>
              }
            </Colxx>
            <Colxx xxs="12">
              <LanguageTabs
                selectedTab={selectedLang === "hk" ? "zh-TW" : selectedLang}
                setLanguage={(e) => setLanguage(e)}
              ></LanguageTabs>

            </Colxx>

            {/* <Colxx xxs="12" className="mb-2 text-right">
            <strong><hr /></strong>
          </Colxx> */}
            <Colxx xxs="12">
              <Row>
                {roomDetail &&
                  roomDetail.rooms &&
                  roomDetail.rooms.map((room, index) => (
                    <Colxx xxs="12" xs="6" lg="3" key={index}>
                      <RoomCard room={room} propertyId={propertyId} locale={selectedLang} categoryList={categoryList} />
                    </Colxx>
                  ))}
              </Row>
            </Colxx>

          </Row>
        </>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(AboutRooms));
